export const CLONE_FORM_REQUEST = "CLONE_FORM_REQUEST";
export const CLONE_FORM_SUCCESS = "CLONE_FORM_SUCCESS";
export const CLONE_FORM_FAILURE = "CLONE_FORM_FAILURE";

export const UPDATE_MODULE_FORM_REQUEST = "UPDATE_MODULE_FORM_REQUEST";
export const UPDATE_MODULE_FORM_SUCCESS = "UPDATE_MODULE_FORM_SUCCESS";
export const UPDATE_MODULE_FORM_FAILURE = "UPDATE_MODULE_FORM_FAILURE";
